import { PermissionNameEnum } from '@Types/permissions';
import { usePermissionStore } from '@Models/usePermissionModel';
import CommonReAuthModal from './commonModal';
import GmailReAuthModal from './gmailModal';
import { ServiceForReAuth } from '@Types/administrator';
import ExchangeInlineReAuthModal from './exchangeInlineModal';
import StorageReauthModal from './storageReauthModal';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';
import TeamsGraphReAuthModal from '@Dashboard/ReAuthModal/teamsGraphModal';
import SharePointGraphReAuthModal from '@Dashboard/ReAuthModal/sharePointGraphModal';
import OneDriveGraphReAuthModal from '@Dashboard/ReAuthModal/oneDriveGraphModal';

const ReAuthModal = ({
  modalState,
  onClose,
  refreshData,
}: {
  modalState: {
    orgId: string;
    service: ServiceForReAuth;
    authAccount: string;
    provisionType: number;
  };
  onClose: () => void;
  refreshData: () => void;
}) => {
  const { service, orgId, authAccount, provisionType } = modalState;
  const { widthEditablePermission } = usePermissionStore();
  const administratorEditPermission = widthEditablePermission(
    PermissionNameEnum.administrator
  );
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();

  if (!administratorEditPermission) {
    return <></>;
  }

  const state = {
    orgId,
    onClose,
    authAccount,
  };

  if (
    service === ServiceForReAuth.Gmail ||
    service === ServiceForReAuth.GmailInline
  ) {
    return <GmailReAuthModal service={service} {...state} />;
  }

  if (
    [
      ServiceForReAuth.Exchange,
      ServiceForReAuth.OneDrive,
      ServiceForReAuth.SharePoint,
      ServiceForReAuth.Teams,
      ServiceForReAuth.TeamsChat,
      ServiceForReAuth.Mip,
      ServiceForReAuth.IdentityProtection,
    ].includes(service)
  ) {
    if (
      service === ServiceForReAuth.Teams &&
      selectedOrgGlobalSetting.newTeamsMultiAppsProvision &&
      provisionType === 1
    ) {
      return <TeamsGraphReAuthModal {...state} />;
    }

    if (
      service === ServiceForReAuth.OneDrive &&
      selectedOrgGlobalSetting.newOnedriveMultiAppsProvision &&
      provisionType === 1
    ) {
      return <OneDriveGraphReAuthModal {...state} />;
    }

    if (
      service === ServiceForReAuth.SharePoint &&
      selectedOrgGlobalSetting.newSharepointMultiAppsProvision &&
      provisionType === 1
    ) {
      return <SharePointGraphReAuthModal {...state} />;
    }

    return (
      <CommonReAuthModal
        service={service}
        refreshData={refreshData}
        {...state}
      />
    );
  }

  if (service === ServiceForReAuth.ExchangeInline) {
    return <ExchangeInlineReAuthModal {...state} />;
  }

  if (
    [
      ServiceForReAuth.Box,
      ServiceForReAuth.Dropbox,
      ServiceForReAuth.GoogleDrive,
    ].includes(service)
  ) {
    return <StorageReauthModal service={service} {...state} />;
  }
  console.warn(`service: ${service} reAuth TODO`);
  return <></>;
};

export default ReAuthModal;
